import React from 'react';
import './About.css';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Button } from 'antd';
import CoreValues from '../../components/CoreValues';
import { whyChooseuS } from '../../utils/constants';

const About = () => {
  return (
    <div className="about-page">
      {/* Header Section */}
      <header className="height-75">
        <div className="container h-100 min-vh-100 d-flex flex-column align-items-center justify-content-center text-light">
          <h1 className="text-center fw-semibold lspacing-10">About Us</h1>
          <h3 className="text-center w-75 mb-5 lspacing-10">
            Built on Precision and Passion
          </h3>
        </div>
      </header>

      {/* Body Section */}
      <div className="container my-5">
        <Row gutter={[24, 24]} justify="center" align="stretch">
          {/* CEO Message Card */}
          <Col xs={24} md={12} style={{ display: 'flex' }}>
            <Card
              title={<h2 className="card-title">Insights from Our CEO</h2>}
              bordered={false}
              className="about-card"
            >
              <div className="card-content">
                <p>Welcome to A to X Engineering Services.</p>
                <p>
                  A To X was founded with a vision to go beyond the ordinary,
                  addressing each project with our skills, technical excellence,
                  and a dedication to quality.
                </p>
                <p>
                  At A To X, we believe that the strength of our work lies in
                  the collective talent and dedication of our team. As a leader,
                  my primary responsibility is to release our team’s potential
                  by building an environment where each member feels valued,
                  inspired, and empowered to bring their best to every project.
                </p>
                <p>
                  For us, a successful project is not just about reaching the
                  finish line but about growing together along the way. We
                  understand that in our space of work, there is no room for
                  compromise on quality, and safety.
                </p>
                <p>
                  Discover the people, purpose, and stories that shape who we
                  are today and guide the plan we’re designing for tomorrow.
                </p>
                <p>
                  Thank you for trusting our vision. We look forward to
                  partnering with you and creating something exceptional
                  together.
                </p>
                <div>
                  <span className="ceo-signature">Tarek Dabdoub</span>
                  <span className="ceo-signature">CEO & Co-Founder</span>
                </div>
              </div>
            </Card>
          </Col>

          {/* Our Story Card */}
          <Col xs={24} md={12} style={{ display: 'flex' }}>
            <Card
              title={<h2 className="card-title">Our Story</h2>}
              bordered={false}
              className="about-card"
            >
              <div className="card-content">
                <p>
                  In the heart of Lebanon, during challenging economic times, A
                  to X Engineering Services was born. We started as a small
                  company with big dreams, driven by years of experience and a
                  strong desire to build something meaningful from the ground
                  up. Our journey began with a spirit of self-reliance, turning
                  obstacles into stepping stones and building our skills along
                  the way.
                </p>
                <p>
                  Inspired by mathematics, we embraced the question for the
                  unknown—always searching for that “X.” This reflects our
                  commitment to solving tough challenges and finding new
                  solutions. Just as every equation has an answer, we believe
                  every project has the potential to yield extraordinary
                  results. Our name embodies that journey: from "A" to "X," we
                  are the bridge that brings your vision to life.
                </p>
                <p>
                  At A To X, we are more than just engineers; we are passionate
                  problem solvers who thrive on teamwork and creativity. We aim
                  to create an environment where our clients feel comfortable,
                  valued, and understood. Your challenges become our challenges,
                  and together, we set out to achieve great things.
                </p>
                <p>
                  Our story is one of resilience, creativity, and the strong
                  belief that with passion and dedication, we can overcome any
                  obstacle. As we continue to grow and move forward, we are
                  committed to delivering exceptional engineering solutions that
                  inspire confidence and lead to success.
                </p>
                <p>
                  Join us as we explore new horizons, always seeking the next
                  "X" that will unlock your project's full potential.
                </p>
                <Row justify="center">
                  <Link to="/contact">
                    <Button
                      type="primary"
                      size="large"
                      className="contact-button bg-blue"
                    >
                      Contact Us
                    </Button>
                  </Link>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Core Values Section */}
      <div className="py-5">
        <CoreValues
          data={whyChooseuS}
          title="WHY CHOOSE US"
          description="Delivering excellence, innovation, and trusted partnerships to drive your success"
        />
      </div>
    </div>
  );
}

export default About;
